import * as React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './modals.styl';
const col3 = 3;
const col9 = 9;
const PasswordResetConfirmModal = ({ t, onSuccess, onClose }) => {
    const onCloseClick = React.useCallback((event) => {
        event.preventDefault();
        onClose();
    }, [onClose]); // eslint-disable-line indent,@typescript-eslint/indent
    return (React.createElement("div", { className: styles.LoginRegistrationModal },
        React.createElement("div", { className: styles.content },
            React.createElement("h4", { className: styles.heading }, t('offerRequest.passwordResetTitle')),
            React.createElement(Container, { fluid: true },
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement("p", { className: styles.description }, t('offerRequest.passwordResetConfirmMessage')))),
                React.createElement(Row, null,
                    React.createElement(Col, { sm: col3, className: styles.pseudoLinkLabel },
                        React.createElement("a", { href: '#', className: styles.pseudoLink, onClick: onCloseClick }, t('offerRequest.close'))),
                    React.createElement(Col, { sm: col9 },
                        React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: onSuccess }, t('offerRequest.requestNewPasswordConfirm'))))))));
};
export default PasswordResetConfirmModal;
